import 'font-awesome/css/font-awesome.min.css';

import React, { Component } from 'react';

import { connect } from 'react-redux';

import LogoHeader from '../Surveylink/Component/LogoHeader';

import { questionsActions, userActions } from '../../_actions';
import { CONST } from '../../_config';


class EmployeeLogin extends Component {
  constructor(props) {
    super(props);

    this.inputChangeEmpId = this.inputChangeEmpId.bind(this);
    this.inputChangeOTP = this.inputChangeOTP.bind(this);

    this.state = {
      emp_id: "",
      otp_code: '',
      notFoundText: "",
      showLogin: true,
      failureMSG: '',
      failureOTPMSG: ''
    }
  }

  componentDidMount() {

    this.props.dispatch(questionsActions.getSurveyDetailsBySurveyCode({ code: this.props.match.params.id }));



  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.user.UserLoginEmailSuccess) {
      return {
        ...nextProps,
        showLogin: false

      }
    }
    if (nextProps.user.getEmployeeStatusSucess) {
      return {
        ...nextProps,
        notFoundText: "Success!"

      }
    }
    if (nextProps.user.getEmployeeStatusFailed) {
      return {
        ...nextProps,
        notFoundText: "Employee not found!"

      }
    } else {
      return {
        ...nextProps
      }
    }

  }


  // handleEmpInput=(e)=>{
  //   this.setState({emp_id: e.target.value});
  // }

  inputChangeEmpId(e) {
    this.setState({ emp_id: e.target.value });
  }

  inputChangeOTP(e) {
    this.setState({ otp_code: e.target.value });
  }

  // submitEmpId=()=>{
  //   let { emp_id } = this.state;
  //   if(emp_id){
  //     this.props.dispatch(userActions.userSurveyLogin({emp_id:emp_id}, this.props));
  //   }
  // }


  submitEmpId = () => {
    let { emp_id } = this.state;
    if (emp_id) {
      this.props.dispatch(userActions.userlogin({ emp_id: emp_id, code: this.props.match.params.id }, this.props));
      this.setState({ failureMSG: '' });
    }
  }


  OTPSubmit = () => {
    const { user } = this.props;
    const { UserEmailToken } = user;
    // console.log("UserEmailToken: ",UserEmailToken)
    let { otp_code } = this.state;
    let data = {
      token: UserEmailToken,
      otp: otp_code,
      code: this.props.match.params.id
    }
    // console.log("data: ",data)
    this.setState({ failureOTPMSG: '' });

    this.props.dispatch(userActions.validateOtp(data, this.props));
  }



  _handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.submitEmpId()
    }
  }

  onTakeSurvey = (code) => {
    // this.props.history.push(`/v2/` + code)
    window.open(CONST.SURVEY_URL + code, "_blank")
  }

  render() {

    let { questions, user } = this.props;
    let { getEmployeeStatusData, employeeMessage, getSurveyDetailsBySurveyCodeData } = questions;
    let { emp_id, notFoundText, otp_code } = this.state;
    let { UserLoginErrorMSG, userLoginData } = user

    console.log("emp_id: ", emp_id);
    console.log("otp_code: ", otp_code);

    let surveyScreenData = getSurveyDetailsBySurveyCodeData;

    let errorMsh = "";
    if (UserLoginErrorMSG) {
      errorMsh = UserLoginErrorMSG;
    }


    console.log("userLoginData----------->: ", userLoginData);


    // let surveyScreenData = {
    //   AlreadyText: "Survey Is Already Submitted !",
    //   ContinueButtonText: "Continue",
    //   ExpiryText: "This Survey is Expired!",
    //   OptionColor1: "#ffffff",
    //   OptionColor2: "#000000",
    //   OptionColor3: "#0770e9",
    //   StartButtonText: "Start Survey",
    //   SubmitButtonText: "Submit",
    //   WriteHereText: "Write here",
    //   bgColor: "#ffffff",
    //   bgImage: "",
    //   bgType: 1,
    //   buttonColor1: "#0069e4",
    //   buttonColor2: "#ffffff",
    //   designTemplate: "v4",
    //   langList:[],
    //   name: "Employee Engagement Survey",
    //   okButtonText: "OK",
    //   textColor: "#262626",
    //   transl: {}
    // }

    const isMobile = window.innerWidth <= 700;

    // if(isMobile){
    //   surveyScreenData["logo2"] = "img/companylogo/kotaklogo2.png";
    // }
    // else{
    //   surveyScreenData["logo2"] = "img/companylogo/kotakbanner.png";
    // }
    // surveyScreenData["logo"] = "img/companylogo/umatters.png";

    // console.log("getSurveyDetailsBySurveyCodeData--------->",getSurveyDetailsBySurveyCodeData);

    console.log("getSurveyDetailsBySurveyCodeData--------->", getSurveyDetailsBySurveyCodeData);


    return (
      <>

        <div className="flex h-screen">
          {/* right section */}
          <div
            className=" bg-[#2196f3] w-5/12 h-full lg:flex hidden flex-col justify-center  items-center space "
          >
            {/* <LogoHeader surveyScreenData={surveyScreenData} template={"v4"} /> */}
            <img
              src={CONST.IMAGES_URL + "/tp_talent_plus_assessment.svg"}
              className="w-11/12 mx-auto"
            />
            <p className="text-xl font-normal capitalize text-white  ">
              Powered by <b className="font-semibold">Happyplus</b>
            </p>
          </div>

          <div className=" lg:w-7/12 w-full h-full flex justify-center items-center bg-slate-100">
            <div className=" w-[40rem]  md:mx-auto mx-6 md:my-6 my-4 space-y-10  bg-white md:p-10 p-6  rounded-lg border">
              <img
                // src={CONST.IMAGES_URL + "/tataprojectlogo4.png"}
                src={surveyScreenData && surveyScreenData.logo ? surveyScreenData.logo : ""}
                // src={"/img/logo/tataprojectlogo.png"}
                className=" bg-cover mx-auto"
              />
              <div className="space-y-4 text-[#3D405B] ">
                <h1 className="md:text-4xl text-2xl font-semibold  text-center ">
                  Welcome to {(surveyScreenData && surveyScreenData.name) ? surveyScreenData.name : ""}
                </h1>
              </div>
              {userLoginData && userLoginData.is360 ?
                <>
                  <div className="bg-white  md:max-w-md  md:mx-auto mx-4 md:my-6 my-4 p-10  ">
                    {/* <label className="p-2 text-xl">Please provide feedback:</label>  <br /> */}
                    <div className='flex justify-center items-center'>
                      <div>
                        <label className="px-4 pb-6 py-3 mb-6">Please provide feedback:</label>  <br />
                        <table className="min-w-full whitespace-nowrap md:px-6 px-4">
                          <thead>
                            <tr className='bg-white'>
                              {/* <th className='px-4 py-3 border-b border-gray-200  text-left leading-4 font-semibold text-slate-800 tracking-wider'>Name</th> */}
                              {/* <th className='px-6 py-3 border-b border-gray-200  text-left leading-4 font-semibold text-slate-800 tracking-wider'>Email</th> */}
                              {/* <th className='px-6 py-3 border-b border-gray-200  text-left leading-4 font-semibold text-slate-800 tracking-wider'>Survey</th> */}
                            </tr>
                          </thead>
                          <tbody className="bg-white">
                            {userLoginData && userLoginData.list && userLoginData.list.length > 0 ?
                              userLoginData.list.map((ele) =>
                                <tr className='font-medium'>
                                  <td className='px-4 py-4   border-b border-gray-200 leading-5'>
                                    <span>{(ele && ele.name ? ele.name : "-")}</span>
                                    <span className='text-red-500'>{(ele && ele.isSelf ? " (Self)" : "")}</span>
                                  </td>
                                  {/* <td className='px-4 py-4   border-b border-gray-200 leading-5'>{ele && ele.emp_id?ele.emp_id:"-"}</td> */}
                                  <td className='px-4 py-4   border-b border-gray-200 leading-5'>
                                    {/* {ele && ele.code?ele.code:"-"} */}
                                    <button className='bg-blue-500 text-white px-4 py-2 w-full my-1 hover:bg-blue-600' onClick={() => this.onTakeSurvey(ele.code)}>Feedback Link</button>
                                  </td>
                                </tr>
                              )
                              : null}
                          </tbody>
                        </table>
                      </div>

                    </div>

                    {/* {errorMsh?
              <>
              <p className="pt-2 text-red-500">{errorMsh}</p>
              <button onClick={()=>this.submitEmpId()} className="bg-blue-500 text-white px-4 py-2 w-full mt-3 hover:bg-blue-600 ">Submit</button>
              </>
              :
              <>
              <button onClick={()=>this.submitEmpId()} className="bg-blue-500 text-white px-4 py-2 w-full mt-6 hover:bg-blue-600 ">Submit</button>
              </>} */}



                  </div>
                </>
                :
                <div className="space-y-2">
                  <label className=" font-semibold text-slate-500 text-lg">
                    Employee ID:
                  </label>
                  <br />
                  <input
                    onKeyDown={this._handleKeyDown}
                    autocomplete="off"
                    type="text"
                    value={emp_id}
                    name="emp_id"
                    onChange={this.inputChangeEmpId}
                    placeholder="Enter here..."
                    className="border bg-white w-full p-3 px-4 text-lg rounded-md focus:outline-none ring-[#2196f3]  transition-all duration-200  focus:ring-1 "
                  />
                </div>
              }

              {errorMsh ? (
                <>
                  <p className=" text-red-500">{errorMsh ? errorMsh + "." : ""}</p>
                  <button
                    onClick={() => this.submitEmpId()}
                    className="w-full  uppercase text-lg font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-3 cursor-pointer  bg-gradient-to-tr bg-[#1368B3] text-white overflow-hidden"
                  >
                    <span class="absolute w-0 h-0 transition-all duration-300 ease-out bg-white rounded-full group-hover:w-[30rem] group-hover:h-[30rem] opacity-10"></span>
                    Submit
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={() => this.submitEmpId()}
                    className="w-full  uppercase text-lg font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-3 cursor-pointer  bg-gradient-to-tr bg-[#1368B3] text-white overflow-hidden"
                  >
                    <span class="absolute w-0 h-0 transition-all duration-300 ease-out bg-white rounded-full group-hover:w-[30rem] group-hover:h-[30rem] opacity-10"></span>
                    Submit
                  </button>
                </>
              )}

              <div className="text-center text-gray-500 mt-8">
                <p className="text-sm px-4 pb-4">
                  {"The survey is CONFIDENTIAL. All data will be directly collected & processed by HappyPlus. No one in the company will have access to individual inputs/feedback."}
                </p>
              </div>



            </div>


          </div>
        </div>



      </>
    );
  }
}
EmployeeLogin.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user } = state;
  return {
    loggingIn,
    questions,
    user

  };
}

export default connect(mapStateToProps)(EmployeeLogin);
